import { Users, AtSign, Building2 } from "lucide-react"
import Reveal from "../../components/Reveal"

const fronts = [
  {
    icon: Users,
    title: "For Individuals",
    status: "Live now",
    statusClass: "bg-green-100 text-green-700",
    description:
      "Anyone who sees a false claim can answer it. Paste a post, get an accurate, fact-based reply, and join the conversation with confidence.",
  },
  {
    icon: AtSign,
    title: "On X",
    status: "In development",
    statusClass: "bg-amber-100 text-amber-700",
    description:
      'Tag @Hasbara_ai under any post and ask "is this true?" - a transparent, public fact-check, right where the conversation is happening.',
  },
  {
    icon: Building2,
    title: "For Organizations",
    status: "Roadmap",
    statusClass: "bg-[#004aad]/10 text-[#004aad]",
    description:
      "An API and analytics layer for institutions: track which hostile narratives are trending, measure their reach, and respond at scale.",
  },
]

const VisionSection = () => {
  return (
    <section id="vision" className="w-full max-w-7xl mx-auto px-4 sm:px-6 pt-8 pb-16">
      <Reveal className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-[#004aad] mb-4 tracking-[-0.01em]">One Engine, Three Fronts</h2>
        <p className="text-[#004aad]/80 text-lg max-w-3xl mx-auto">
          The same core - detection, a vetted knowledge base, and calibrated response generation -
          can serve everyone, from a single supporter to the State of Israel.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        {fronts.map((front, idx) => {
          const Icon = front.icon
          return (
            <Reveal key={idx} delay={idx * 80} className="h-full">
              <div
                data-ai-surface="card"
                className="h-full bg-white border border-[#004aad]/20 rounded-2xl p-7 shadow-[0_4px_20px_rgba(0,74,173,0.08)] transition-[transform,box-shadow,border-color] duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] hover:shadow-[0_14px_34px_rgba(0,74,173,0.16)] hover:border-[#004aad]/40 hover:-translate-y-1"
              >
                <div className="flex items-center justify-between mb-4">
                  <div className="bg-[#004aad]/10 p-3 rounded-lg">
                    <Icon className="w-6 h-6 text-[#004aad]" />
                  </div>
                  <span className={`text-xs font-semibold px-3 py-1 rounded-full ${front.statusClass}`}>
                    {front.status}
                  </span>
                </div>
                <h3 className="text-[#004aad] font-semibold text-xl mb-2">{front.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{front.description}</p>
              </div>
            </Reveal>
          )
        })}
      </div>
    </section>
  )
}

export default VisionSection
